/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FidelitycaService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Pdf Signed Url
     * @param eventId
     * @returns string Successful Response
     * @throws ApiError
     */
    public getKycPdfSignedUrl(
        eventId: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/enterprise/fidelityca/{event_id}/pdf/kyc',
            path: {
                'event_id': eventId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Build Kyc Pdf
     * @param eventId
     * @returns string Successful Response
     * @throws ApiError
     */
    public buildKycPdf(
        eventId: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/enterprise/fidelityca/{event_id}/pdf/kyc/build',
            path: {
                'event_id': eventId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
